import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbnailPreview from "../components/ThumbnailPreview";

export default () => {
  const url = `${process.env.REACT_APP_BASE_URL}admin/homepagecarousel`;
  const token = localStorage.getItem("token");
  const [open, setOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fileName, setFileName] = useState("");
  const [imagesData, setImagesData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [editOrder, setEditOrder] = useState(1);
  const [youtubeDarshanLink, setYoutubeDarshanLink] = useState("");
  const [grandOpeningDate, setGrandOpeningDate] = useState("");

  const init = async () => {
    setLoading(true);
    try {
      const res = await fetch(url, {
        headers: {
          Authorization: token,
        },
      });
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const responseData = await res.json();

      if (responseData.data && Array.isArray(responseData.data)) {
        const mainData = [...responseData.data].sort((a, b) => a.order - b.order);
        setImagesData(mainData);
      } else {
        setImagesData([]);
      }// Set darshanObject data to global settings
      if (responseData.darshanObject) {
        setYoutubeDarshanLink(responseData.darshanObject.youtubeDarshanLink || "");
        setGrandOpeningDate(responseData.darshanObject.grandOpeningDate || "");
      }
      // load global settings (stored locally for now)
      try {

      } catch (_) { }
    } catch (error) {
      setImagesData([]);
    } finally {
      setLoading(false);
    }
  };

  const updateList = (list) => {
    const mainData = [];
    list.forEach((item, i) => {
      mainData.push({
        ...item,
        order: i + 1,
      });
    });

    fetch(url, {
      method: "PUT",
      headers: { "content-type": "application/json", Authorization: token },
      body: JSON.stringify(mainData),
    });
  };

  const onDelete = (index) => {
    fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify({ id: imagesData[index]._id }),
    });
    const newImages = [...imagesData];
    newImages.splice(index, 1);

    setImagesData(newImages);
  };

  const openEdit = (row, index) => {
    setEditRow({ ...row, index });
    setEditOrder(row.order || index + 1);
    setEditOpen(true);
  };

  const saveEdit = () => {
    if (editRow == null) return setEditOpen(false);
    const newOrder = Number(editOrder) || (editRow.index + 1);
    const updated = imagesData.map((item, i) =>
      i === editRow.index
        ? {
          ...item,
          order: newOrder,
        }
        : item
    );
    // Normalize orders: sort by order then reassign 1..n to avoid duplicates
    const normalized = [...updated]
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item, i) => ({ ...item, order: i + 1 }));
    setImagesData(normalized);
    updateList(normalized);
    setEditOpen(false);
    setEditRow(null);
  };

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first!");
      return;
    }

    setUploading(true);

    try {
      const base64Image = await convertFileToBase64(selectedFile);

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          image: base64Image,
          order: imagesData.length,
        }),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const resData = await res.json();

      setImagesData((prev) => [
        ...prev,
        {
          order: resData.order,
          url: resData.url,
          _id: resData._id,
        },
      ]);

      setUploading(false);
      setOpen(false);
      setSelectedFile(null);
    } catch (error) {
      console.error("Upload error:", error);
      setUploading(false);
    }
  };



  useEffect(() => {
    init();
  }, []);

  const saveGlobalSettings = async () => {
    const payload = {
      youtubeDarshanLink,
      grandOpeningDate,
    };

    // localStorage.setItem("homepageSettings", JSON.stringify(payload));
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}updateDarshan/690d0d1c2dd351533efef9a3`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      console.log("Updated:", result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <Box style={{ width: "100%", marginTop: 8, marginBottom: 16 }}>
        <Typography variant="h6" gutterBottom>
          Homepage Settings
        </Typography>
        <Box style={{ display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "nowrap" }}>
          <TextField
            label="Live YouTube Darshan Link"
            value={youtubeDarshanLink}
            onChange={(e) => setYoutubeDarshanLink(e.target.value)}
            fullWidth
            style={{ flex: 1, minWidth: 420 }}
          />
          <TextField
            type="date"
            label="Grand Opening (Date)"
            value={grandOpeningDate}
            onChange={(e) => setGrandOpeningDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ width: 220 }}
          />
          <Button onClick={saveGlobalSettings} variant="contained">Save</Button>
          <Button onClick={() => setOpen(true)} variant="outlined">Upload</Button>
        </Box>
      </Box>
      <Divider style={{ width: "100%", marginBottom: 12 }} />
      {loading ? (
        <div style={{ padding: "20px", textAlign: "center", width: "100%" }}>
          <Typography variant="body1">Loading carousel images...</Typography>
        </div>
      ) : (
        <TableContainer component={Paper} style={{ width: "100%", marginTop: 16 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 80 }}>Order</TableCell>
                <TableCell>Image</TableCell>
                <TableCell align="right" style={{ width: 160 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {imagesData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Typography variant="body2">No carousel images found. Upload some images to get started.</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                imagesData.map((row, index) => (
                  <TableRow key={row._id || index} hover>
                    <TableCell>{row.order || index + 1}</TableCell>
                    <TableCell>
                      <ThumbnailPreview src={row.url} alt={`carousel-${index}`} maxWidth={160} />
                    </TableCell>
                    <TableCell align="right">
                      <IconButton aria-label="edit" onClick={() => openEdit(row, index)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton aria-label="delete" color="error" onClick={() => onDelete(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Dialog
        open={open}
        onClose={() => {
          if (!uploading) setOpen(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Upload Image</DialogTitle>
        <DialogContent>
          <Typography
            variant="caption"
            component="h6"
            style={{ marginBottom: "10px" }}
          >
            {fileName && fileName.path ? fileName.path : fileName}
          </Typography>
          <div
            styles={{
              padding: "20px",
              border: "3px dashed #eeeeee",
              backgroundColor: "#ccccb3",
              color: "black",
            }}
          >
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                setSelectedFile(file);
                setFileName(file ? file.name : "");
              }}
            />
            <p>Drag'n'drop images, or click to select files</p>
          </div>
          {/* Global fields moved to settings above */}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={uploading}
            onClick={() => setOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button disabled={uploading} onClick={handleUpload} color="primary">
            {uploading ? "Uploading" : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={editOpen} onClose={() => setEditOpen(false)} aria-labelledby="edit-dialog-title">
        <DialogTitle id="edit-dialog-title">Edit Slide</DialogTitle>
        <DialogContent>
          <TextField
            type="number"
            label="Order"
            value={editOrder}
            onChange={(e) => setEditOrder(e.target.value)}
            fullWidth
            inputProps={{ min: 1 }}
          />
          {/* Global fields moved to settings above */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditOpen(false)} color="primary">Cancel</Button>
          <Button onClick={saveEdit} color="primary" variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
